import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

class InsuranceQuoteFormController extends Controller {
  static targets = ['country', 'stateSelect']
  static values = { enabledCountry: String }

  connect () {
    if (!this.hasCountryTarget || !this.hasStateSelectTarget) return
    this.updateStateSelect()
  }

  updateStateSelect () {
    this.#isCountryMatch() ? this.#enableState() : this.#disableState()
  }

  #enableState () {
    this.stateSelectTarget.disabled = false
    this.stateSelectTarget.dispatchEvent(new CustomEvent('enable'))
  }

  #disableState () {
    this.stateSelectTarget.disabled = true

    const container = this.stateSelectTarget.closest('[data-controller~="choices"]')
    if (!container) return
    const choicesController = this.application.getControllerForElementAndIdentifier(container, 'choices')
    if (choicesController?.choices) {
      choicesController.choices.removeActiveItems()
      choicesController.choices.disable()
    }
  }

  #isCountryMatch () {
    return this.countryTarget.value === this.enabledCountryValue
  }
}

stimulus.register('insurance-quote-form', InsuranceQuoteFormController)
